// 宮崎県のパワースポット・神社に関する四択問題100問 - 10問1セット×10セット

export const quizSets = [
  {
    id: 1,
    title: "セット1: 高千穂地方の神話と神社",
    category: "高千穂",
    questions: [
      {
        id: 1,
        question: "天照大神が隠れたとされる「天岩戸」を御神体とし、岩戸川を挟んで東本宮と西本宮が鎮座する神社の名称は何か。",
        options: [
          "高千穂神社",
          "天岩戸神社",
          "槵触神社",
          "荒立神社"
        ],
        correctAnswer: 1,
        explanation: "天岩戸神社は、天照大神が隠れたとされる天岩戸を御神体として祀る神社です。西本宮の背後の岩戸川沿いに天岩戸が存在し、東本宮は天照大神が最初に出現した場所とされます。"
      },
      {
        id: 2,
        question: "天岩戸神社の西本宮から徒歩約10分の場所にある、八百万の神々が天照大神を岩戸から出すための相談をした場所とされるのはどこか。",
        options: [
          "天安河原",
          "天孫降臨の地",
          "みそぎ池",
          "神庭の滝"
        ],
        correctAnswer: 0,
        explanation: "天安河原は、八百万の神々が集まって相談を行ったとされる神話の地です。仰慕窟という大きな洞窟があり、現在もその神聖な雰囲気から多くの参拝者が訪れます。"
      },
      {
        id: 3,
        question: "高千穂神社の御神木である「秩父杉」は、樹齢何年とされているか。",
        options: [
          "500年",
          "800年",
          "1200年",
          "1500年"
        ],
        correctAnswer: 1,
        explanation: "高千穂神社の境内にそびえる秩父杉は、樹齢約800年と伝えられる御神木です。この杉の周囲を夫婦や恋人が手をつないで3回まわると、縁結び・夫婦円満の御利益があるとされます。"
      },
      {
        id: 4,
        question: "高千穂神社で毎晩奉納される「高千穂の夜神楽」の代表的な演目の一つで、夫婦和合・縁結びの舞として知られるものは何か。",
        options: [
          "岩戸開き",
          "手力雄の舞",
          "御神体の舞",
          "四季の舞"
        ],
        correctAnswer: 2,
        explanation: "御神体の舞は、イザナギとイザナミの夫婦神が登場し、国生み神話を演じる舞です。高千穂神社では、この舞を含む代表的な演目を毎晩観光客向けに公開しています。"
      },
      {
        id: 5,
        question: "天孫降臨の際、瓊瓊杵尊が最初に降り立ったとされる「櫛觸の峰」の頂上に鎮座する神社の名称は何か。",
        options: [
          "国見ヶ丘神社",
          "槵触神社（くしふるじんじゃ）",
          "二上神社",
          "高天原神社"
        ],
        correctAnswer: 1,
        explanation: "槵触神社は、天孫降臨の第一歩の地とされる櫛觸の峰に鎮座しています。瓊瓊杵尊がこの峰に降臨した後、高千穂峰に移られたという伝承があります。"
      },
      {
        id: 6,
        question: "芸能の神である天鈿女命と猿田彦命を祀り、芸能・縁結びの御利益で知られる高千穂の神社はどこか。",
        options: [
          "天岩戸神社",
          "荒立神社",
          "二上神社",
          "落立神社"
        ],
        correctAnswer: 1,
        explanation: "荒立神社は、天鈿女命と猿田彦命を祀る神社で、天鈿女命が芸能の神であることから、芸能上達や縁結びの御利益があるとされています。"
      },
      {
        id: 7,
        question: "高千穂峡の真名井の滝の上流にあり、天孫降臨の際に天村雲命が水種を移したとされる池の名称は何か。",
        options: [
          "神池",
          "おのころ池",
          "みそぎ池",
          "天鏡池"
        ],
        correctAnswer: 2,
        explanation: "みそぎ池は、天孫降臨の際に天村雲命が天の真名井の水を移したとされる場所です。この水が真名井の滝となって高千穂峡に流れ落ちています。"
      },
      {
        id: 8,
        question: "高千穂町の国見ヶ丘は、神武天皇の孫である建磐龍命が九州統治の際に国見をしたとされる場所である。この丘から見える幻想的な自然現象は何か。",
        options: [
          "ダイヤモンド富士",
          "雲海",
          "蜃気楼",
          "オーロラ"
        ],
        correctAnswer: 1,
        explanation: "秋から初冬の早朝、国見ヶ丘からは高千穂盆地を覆う雲海を見ることができます。この幻想的な光景は、「雲海に浮かぶ山々」として人気の絶景スポットとなっています。"
      },
      {
        id: 9,
        question: "高千穂神社の祭神の中心となる「高千穂皇神」とは、どのような神々の総称か。",
        options: [
          "天照大神と素戔嗚尊",
          "瓊瓊杵尊とその子孫である日向三代の神々",
          "イザナギとイザナミ",
          "天御中主神を中心とする造化三神"
        ],
        correctAnswer: 1,
        explanation: "高千穂皇神は、瓊瓊杵尊、彦火火出見尊、鵜鵝草葺不合尊など、日向三代と称される神々の総称です。高千穂神社はこれらの神々を祀る、地域で最も重要な神社の一つです。"
      },
      {
        id: 10,
        question: "高千穂神社の本殿・拝殿は、国の重要文化財に指定されている。この社殿を再建したのは何時代か。",
        options: [
          "平安時代",
          "鎌倉時代",
          "室町時代",
          "江戸時代"
        ],
        correctAnswer: 2,
        explanation: "現在の高千穂神社の本殿は、天正年間（1573～1592年）の室町時代末期に再建されたもので、五間社流造という建築様式の優れた例として国の重要文化財に指定されています。"
      }
    ]
  },
  {
    id: 2,
    title: "セット2: 初代天皇ゆかりの地",
    category: "初代天皇",
    questions: [
      {
        id: 11,
        question: "神武天皇（神日本磐余彦尊）を主祭神として祀り、宮崎市の中心部に鎮座する神社の名称は何か。",
        options: [
          "江田神社",
          "宮崎神宮",
          "皇宮神社",
          "狭野神社"
        ],
        correctAnswer: 1,
        explanation: "宮崎神宮は、初代天皇である神武天皇を主祭神として祀る神社です。神武天皇が東征前に宮を営んだ地とされ、「神武天皇宮」とも呼ばれます。"
      },
      {
        id: 12,
        question: "宮崎神宮の社殿の建築様式として正しいものはどれか。",
        options: [
          "神明造",
          "大社造",
          "春日造",
          "流造"
        ],
        correctAnswer: 0,
        explanation: "宮崎神宮の社殿は、伊勢神宮と同じ「神明造」という建築様式です。シンプルで古式ゆかしい造りが特徴で、この様式は日本最古の神社建築様式の一つとされます。"
      },
      {
        id: 13,
        question: "神武天皇の父である鵜鵝草葺不合尊が生まれた場所とされ、海岸の洞窟内に本殿がある神社はどこか。",
        options: [
          "青島神社",
          "鵜戸神宮",
          "都萬神社",
          "巨田神社"
        ],
        correctAnswer: 1,
        explanation: "鵜戸神宮は、日向灘に面した断崖の洞窟内に本殿があり、鵜鵝草葺不合尊の生誕地とされています。安産・育児の神として信仰を集めています。"
      },
      {
        id: 14,
        question: "鵜戸神宮の御本殿前の海岸にある亀石の桝形の窪みに向かって、男性は左手、女性は右手で願いを込めながら運玉を投げ、入れば願いが叶うとされる。この「運玉」は何でできているか。",
        options: [
          "陶器",
          "木材",
          "石",
          "粘土"
        ],
        correctAnswer: 0,
        explanation: "運玉は素焼きの陶器でできた玉です。男性は左手、女性は右手で投げ、亀石の桝形の窪みに入ると願いが叶うとされる人気の祈願方法です。"
      },
      {
        id: 15,
        question: "神武天皇が生まれた場所とされ、高原町に鎮座する神社の名称は何か。",
        options: [
          "狭野神社",
          "霧島神宮",
          "東霧島神社",
          "皇子原神社"
        ],
        correctAnswer: 0,
        explanation: "狭野神社は、神武天皇の生誕地とされる場所に鎮座し、神武天皇の幼名である「狭野尊（さののみこと）」を祀っています。境内には樹齢千年を超える杉の巨木が立ち並びます。"
      },
      {
        id: 16,
        question: "神武天皇が生まれ育った宮居の跡とされ、高原町にある「皇子原公園」には何が復元されているか。",
        options: [
          "古墳",
          "神殿",
          "古代住居",
          "石造りの城壁"
        ],
        correctAnswer: 1,
        explanation: "皇子原公園には、神武天皇が生まれ育った宮居跡として神殿が復元されています。周辺は古代の雰囲気を感じられる歴史公園として整備されています。"
      },
      {
        id: 17,
        question: "イザナギとイザナミが国生みの後に禊を行ったとされる「阿波岐原」に鎮座し、みそぎ・祓いの神を祀る神社はどこか。",
        options: [
          "江田神社",
          "阿波岐原神社",
          "住吉神社",
          "宮崎神宮"
        ],
        correctAnswer: 0,
        explanation: "江田神社は、イザナギが禊を行った阿波岐原の伝承地に鎮座し、禊祓の神を祀っています。この禊の際に天照大神や素戔嗚尊などが生まれたとされます。"
      },
      {
        id: 18,
        question: "江田神社の近くにある「みそぎ池」は、イザナギの禊の際に何柱の神が生まれたとされるか。",
        options: [
          "三柱（住吉三神）",
          "五柱",
          "七柱",
          "十二柱"
        ],
        correctAnswer: 0,
        explanation: "みそぎ池では、イザナギの禊の際に底筒男命、中筒男命、表筒男命の住吉三神が生まれたとされています。この池は現在も江田神社の境内に存在しています。"
      },
      {
        id: 19,
        question: "宮崎神宮の「御田植祭」では、田植えの後にある伝統芸能が奉納される。その芸能の名称は何か。",
        options: [
          "夜神楽",
          "御田植踊り",
          "田楽",
          "獅子舞"
        ],
        correctAnswer: 1,
        explanation: "宮崎神宮の御田植祭では、神田での田植えの後、白装束の早乙女たちによる「御田植踊り」が奉納されます。五穀豊穣を祈願する伝統行事です。"
      },
      {
        id: 20,
        question: "鵜戸神宮で授与される、安産・育児のお守りとして有名なものは何か。",
        options: [
          "お乳飴",
          "白い布",
          "小さな鈴",
          "おちちあめ"
        ],
        correctAnswer: 3,
        explanation: "鵜戸神宮では「おちちあめ」が授与されます。これは豊玉姫が乳房を岩に託したという伝承にちなみ、母乳の出がよくなる、また赤ちゃんが健やかに育つとされる縁起物です。"
      }
    ]
  },
  {
    id: 3,
    title: "セット3: 日向灘と海の信仰",
    category: "海の信仰",
    questions: [
      {
        id: 21,
        question: "青島全島が境内となっている青島神社の主祭神で、山幸彦として知られる神は誰か。",
        options: [
          "彦火火出見尊",
          "瓊瓊杵尊",
          "鵜鵝草葺不合尊",
          "神日本磐余彦尊"
        ],
        correctAnswer: 0,
        explanation: "青島神社の主祭神は彦火火出見尊（山幸彦）です。海神の宮から戻った後、豊玉姫と結ばれた場所が青島とされ、縁結びの神社として人気があります。"
      },
      {
        id: 22,
        question: "青島を取り囲む波状岩の奇観は、「鬼の洗濯板」と呼ばれている。この地形の正式な地質学的名称は何か。",
        options: [
          "柱状節理",
          "甌穴",
          "隆起海床と奇形波蝕痕",
          "風化花崗岩"
        ],
        correctAnswer: 2,
        explanation: "青島を取り囲む波状の岩は、「隆起海床と奇形波蝕痕」という地質学的に貴重な地形です。約700万年前の地層が隆起し、波の浸食を受けてできた特殊な景観です。"
      },
      {
        id: 23,
        question: "青島神社で、ハート形の絵馬や、真っ赤な社殿が人気を集めているが、この神社が特に御利益があるとされる分野は何か。",
        options: [
          "商売繁盛",
          "縁結び・恋愛成就",
          "学業成就",
          "交通安全"
        ],
        correctAnswer: 1,
        explanation: "青島神社は、山幸彦と豊玉姫の恋物語の舞台とされることから、縁結び・恋愛成就の御利益で有名です。ハート形の絵馬や、恋みくじなど、恋愛にちなんだ授与品が人気です。"
      },
      {
        id: 24,
        question: "日向市の金ヶ浜にある大御神社は、「日向のお伊勢さま」とも呼ばれる。この神社の主祭神は誰か。",
        options: [
          "素戔嗚尊",
          "天照大神",
          "月読尊",
          "大国主命"
        ],
        correctAnswer: 1,
        explanation: "大御神社は天照大神を主祭神とし、伊勢神宮との深い関わりから「日向のお伊勢さま」と呼ばれています。境内からは日向灘の絶景を望むことができます。"
      },
      {
        id: 25,
        question: "大御神社の境内にある、龍神が宿るとされる「龍神岩」には、どのような特徴があるか。",
        options: [
          "巨大な亀の形をしている",
          "柱状の岩が林立している",
          "岩の表面に龍の模様が浮かび上がる",
          "満潮時には海に沈む"
        ],
        correctAnswer: 1,
        explanation: "龍神岩は、柱状節理の岩が林立する神秘的な景観を持ち、古来より龍神が宿る聖地として崇められてきました。パワースポットとして人気を集めています。"
      },
      {
        id: 26,
        question: "日南市の潮嶽神社で祀られている主祭神は、神話では弟に敗れた悲運の神として知られる。この神は誰か。",
        options: [
          "海幸彦（火照命）",
          "山幸彦（彦火火出見尊）",
          "鵜鵝草葺不合尊",
          "大国主命"
        ],
        correctAnswer: 0,
        explanation: "潮嶽神社は、海幸彦（火照命）を主祭神として祀る珍しい神社です。神話では弟の山幸彦に敗れましたが、地元では海の神、漁業の神として崇敬されています。"
      },
      {
        id: 27,
        question: "門川町の乙島には、古くから女性の参拝が禁じられてきた「女人禁制」の伝統を持つ神社がある。この神社の名称は何か。",
        options: [
          "乙島神社",
          "尾末神社",
          "海神神社",
          "厳島神社"
        ],
        correctAnswer: 1,
        explanation: "尾末神社は、乙島に鎮座し、長い間女人禁制の伝統が守られてきました。現在は緩和されていますが、神聖な海の信仰を今に伝える場所です。"
      },
      {
        id: 28,
        question: "日南海岸にある「願いが叶うクルスの海」と呼ばれる場所は、海岸の岩と波が作り出すある形が特徴的である。その形とは何か。",
        options: [
          "ハート型",
          "十字架",
          "星形",
          "三日月"
        ],
        correctAnswer: 1,
        explanation: "クルスの海は、海岸の岩の裂け目と波が作り出す白波が十字架の形に見える絶景スポットです。「クルス」はポルトガル語で十字を意味し、願いが叶う場所として人気です。"
      },
      {
        id: 29,
        question: "鵜戸神宮がある海岸一帯は、ある独特の地形が見られる国の名勝に指定されている。その地形の名称は何か。",
        options: [
          "リアス式海岸",
          "鬼の洗濯板",
          "洞窟海岸",
          "砂丘海岸"
        ],
        correctAnswer: 1,
        explanation: "鵜戸神宮周辺の海岸には、青島と同様に「鬼の洗濯板」と呼ばれる波状岩の地形が広がっており、日南海岸として国の名勝に指定されています。"
      },
      {
        id: 30,
        question: "青島の亜熱帯性植物群落は、国の特別天然記念物に指定されている。この植物群落を代表する植物の一つは何か。",
        options: [
          "ビロウ",
          "ソテツ",
          "マングローブ",
          "ガジュマル"
        ],
        correctAnswer: 0,
        explanation: "青島には約200種以上の亜熱帯植物が自生しており、特にビロウという椰子科の植物が密生する「ビロウ樹林」が有名です。この植物群落は学術的にも貴重で、特別天然記念物に指定されています。"
      }
    ]
  },
  {
    id: 4,
    title: "セット4: 山々と渓谷の信仰（霧島・都城）",
    category: "山の信仰",
    questions: [
      {
        id: 31,
        question: "瓊瓊杵尊が天孫降臨した地とされる霊峰の名称は何か。",
        options: [
          "阿蘇山",
          "高千穂峰",
          "祖母山",
          "市房山"
        ],
        correctAnswer: 1,
        explanation: "高千穂峰は、瓊瓊杵尊が天孫降臨した地とされる標高1,574mの霊峰です。頂上には「天の逆鉾」が立っており、神話と信仰の山として崇められています。"
      },
      {
        id: 32,
        question: "高千穂峰の山頂に突き立てられている「天の逆鉾」は、ある人物が引き抜いてまた元に戻したという逸話がある。その人物は誰か。",
        options: [
          "西郷隆盛",
          "島津斉彬",
          "坂本龍馬",
          "勝海舟"
        ],
        correctAnswer: 2,
        explanation: "幕末の志士・坂本龍馬が新婚旅行で高千穂峰に登った際、天の逆鉾を引き抜いてすぐに元に戻したという有名な逸話が残されています。"
      },
      {
        id: 33,
        question: "霧島山系の中心的な神社で、瓊瓊杵尊を主祭神として祀る「霧島神宮」は、何県に鎮座しているか。",
        options: [
          "宮崎県",
          "鹿児島県",
          "熊本県",
          "宮崎県と鹿児島県の県境"
        ],
        correctAnswer: 1,
        explanation: "霧島神宮は鹿児島県霧島市に鎮座していますが、宮崎県との県境に近く、古くから日向・大隅両国の信仰を集めてきた霊山・霧島山系の中心的な神社です。"
      },
      {
        id: 34,
        question: "都城市の東霧島神社は、神武天皇の祖父に当たるある神を主祭神として祀っている。その神は誰か。",
        options: [
          "瓊瓊杵尊",
          "彦火火出見尊",
          "鵜鵝草葺不合尊",
          "天照大神"
        ],
        correctAnswer: 2,
        explanation: "東霧島神社の主祭神は鵜鵝草葺不合尊です。神武天皇の父である鵜鵝草葺不合尊が、龍神の姿で現れて霧を払ったという伝承があり、「霧払いの神」として信仰されています。"
      },
      {
        id: 35,
        question: "東霧島神社の参道に配置されている、神代の時代を表す特徴的な石段は何段あるか。",
        options: [
          "333段",
          "444段",
          "555段",
          "666段"
        ],
        correctAnswer: 2,
        explanation: "東霧島神社の参道には、神代（じんだい）を表す555段の石段「振り向かずの坂」があります。この石段を一気に登り切ると願いが叶うとされています。"
      },
      {
        id: 36,
        question: "都城市の母智丘（もちお）公園には、ある神を祀る神社がある。この神社の主祭神は誰か。",
        options: [
          "瓊瓊杵尊とコノハナサクヤヒメ",
          "イザナギとイザナミ",
          "天照大神",
          "大国主命"
        ],
        correctAnswer: 0,
        explanation: "母智丘神社は、瓊瓊杵尊とコノハナサクヤヒメを主祭神として祀っています。春には桜の名所として知られる母智丘公園の中に鎮座しています。"
      },
      {
        id: 37,
        question: "西都市と西米良村の境にそびえる霊峰・市房山の山頂には、ある神を祀る神社がある。この神社の名称は何か。",
        options: [
          "市房神社",
          "山頂神社",
          "市房山神宮",
          "霊峰神社"
        ],
        correctAnswer: 0,
        explanation: "市房山の山頂には市房神社の上宮が鎮座しており、山岳信仰の聖地となっています。水の神、農業の神として古くから崇敬されてきました。"
      },
      {
        id: 38,
        question: "綾町の照葉大吊橋の近くにある、縁結びと幸福を呼ぶとされる「綾の○○大つり橋」の○○に入る言葉は何か。",
        options: [
          "恋",
          "愛",
          "幸せ",
          "絆"
        ],
        correctAnswer: 1,
        explanation: "正式には「綾の照葉大吊橋」ですが、「愛のかけ橋」とも呼ばれ、カップルや夫婦で訪れると幸せになれるとされるパワースポットです。"
      },
      {
        id: 39,
        question: "椎葉村の深い山中にある十根川神社は、ある伝説の人物を祀っている。その人物は誰か。",
        options: [
          "源義経",
          "平家の落人",
          "那須大八郎",
          "菅原道真"
        ],
        correctAnswer: 1,
        explanation: "十根川神社は、平家の落人を祀る神社として知られています。壇ノ浦の戦いの後、この地に逃れてきた平家の人々が、先祖を供養するために建てたとされます。"
      },
      {
        id: 40,
        question: "高千穂町の二上神社の御神木である「夫婦杉」は、どのような特徴を持つか。",
        options: [
          "2本の杉が根元で繋がっている",
          "1本の杉が途中から2本に分かれている",
          "2本の杉がお互いに寄り添うように立っている",
          "1本の杉が螺旋状にねじれている"
        ],
        correctAnswer: 0,
        explanation: "二上神社の夫婦杉は、2本の巨大な杉が根元で一つに繋がっている珍しい形をしており、夫婦円満・縁結びの象徴として崇められています。"
      }
    ]
  },
  {
    id: 5,
    title: "セット5: 西都原と古墳の聖地",
    category: "古墳",
    questions: [
      {
        id: 41,
        question: "西都原古墳群の中にあり、瓊瓊杵尊と木花開耶姫を祀る神社の名称は何か。",
        options: [
          "都萬神社",
          "男狭穂塚・女狭穂塚神社",
          "記紀の道神社",
          "西都原神社"
        ],
        correctAnswer: 1,
        explanation: "西都原古墳群には、男狭穂塚を瓊瓊杵尊の陵墓、女狭穂塚を木花開耶姫の陵墓とする伝承があり、これらの古墳は宮内庁によって陵墓参考地として管理されています。"
      },
      {
        id: 42,
        question: "西都市の都萬神社は、「日本の○○発祥の地」として知られている。○○に入る言葉は何か。",
        options: [
          "米作り",
          "酒造り",
          "養蚕",
          "製鉄"
        ],
        correctAnswer: 1,
        explanation: "都萬神社は「日本酒発祥の地」として知られています。木花開耶姫が瓊瓊杵尊との結婚を祝って、米で酒を醸したという伝承に基づいています。"
      },
      {
        id: 43,
        question: "都萬神社の主祭神である木花開耶姫は、どのような御利益で知られているか。",
        options: [
          "学業成就・合格祈願",
          "安産・子授け・縁結び",
          "商売繁盛・金運",
          "病気平癒・健康長寿"
        ],
        correctAnswer: 1,
        explanation: "木花開耶姫は、一夜で懐妊し三人の子を無事出産したという神話から、安産・子授け・縁結びの神として崇敬されています。"
      },
      {
        id: 44,
        question: "西都原古墳群には、約何基の古墳が存在するか。",
        options: [
          "100基",
          "200基",
          "300基",
          "400基"
        ],
        correctAnswer: 2,
        explanation: "西都原古墳群には、大小約300基の古墳が点在しており、日本最大級の古墳群の一つとなっています。国の特別史跡に指定されています。"
      },
      {
        id: 45,
        question: "西都原古墳群で最大の前方後円墳である「男狭穂塚」の全長は約何メートルか。",
        options: [
          "76m",
          "136m",
          "176m",
          "236m"
        ],
        correctAnswer: 2,
        explanation: "男狭穂塚は全長約176mの九州最大級の前方後円墳です。宮内庁により瓊瓊杵尊の陵墓参考地として治定されており、立ち入りが制限されています。"
      },
      {
        id: 46,
        question: "西都原古墳群の中で、内部を見学できる古墳の名称は何か。",
        options: [
          "鬼の窟古墳",
          "酒元ノ上横穴墓群",
          "第81号墳",
          "上記すべて"
        ],
        correctAnswer: 3,
        explanation: "西都原古墳群では、鬼の窟古墳（第100号墳）、酒元ノ上横穴墓群、第81号墳など、複数の古墳で内部を見学することができます。古代の埋葬施設を直接体験できる貴重な場所です。"
      },
      {
        id: 47,
        question: "西都原考古博物館に隣接する「古代生活体験館」では、ある古墳時代の技術を体験できる。その技術とは何か。",
        options: [
          "土器づくり",
          "勾玉づくり",
          "火起こし",
          "上記すべて"
        ],
        correctAnswer: 3,
        explanation: "古代生活体験館では、土器づくり、勾玉づくり、火起こしなど、古代の生活技術を実際に体験することができます。歴史学習の場として人気です。"
      },
      {
        id: 48,
        question: "西都原古墳群が築かれた時代は、主にいつ頃か。",
        options: [
          "弥生時代",
          "古墳時代",
          "飛鳥時代",
          "奈良時代"
        ],
        correctAnswer: 1,
        explanation: "西都原古墳群は、主に3世紀から7世紀にかけての古墳時代に築かれました。この地域が長期にわたって強大な勢力の中心地であったことを示しています。"
      },
      {
        id: 49,
        question: "西都原古墳群の「鬼の窟古墳」の内部構造の特徴として正しいものはどれか。",
        options: [
          "竪穴式石室",
          "横穴式石室",
          "木棺直葬",
          "甕棺"
        ],
        correctAnswer: 1,
        explanation: "鬼の窟古墳（第100号墳）は、横穴式石室を持つ円墳です。内部は全長10.3mに及ぶ巨大な石室で、玄室に入ることができます。"
      },
      {
        id: 50,
        question: "毎年春と秋に西都原古墳群で見られる、一面を彩る花の景観として有名なものは何か。",
        options: [
          "春は桜、秋は紅葉",
          "春は菜の花、秋はコスモス",
          "春はツツジ、秋はススキ",
          "春は藤、秋は彼岸花"
        ],
        correctAnswer: 1,
        explanation: "西都原古墳群では、春には約30万本の菜の花が、秋には約300万本のコスモスが一面に咲き誇り、古墳と花の絶景が楽しめます。"
      }
    ]
  },
  {
    id: 6,
    title: "セット6: 延岡・日向の聖地",
    category: "延岡・日向",
    questions: [
      {
        id: 51,
        question: "延岡市の今山に鎮座し、神武天皇の東征前の「お舟出の地」とされる神社の名称は何か。",
        options: [
          "今山八幡宮",
          "今山神社",
          "延岡神社",
          "祇園神社"
        ],
        correctAnswer: 0,
        explanation: "今山八幡宮は、神武天皇が東征に出発する際、この地で船出の準備をしたという伝承があります。延岡市街を見下ろす今山の頂上に鎮座しています。"
      },
      {
        id: 52,
        question: "延岡市の愛宕山に鎮座する「愛宕神社」は、火防の神として知られるが、毎年2月に行われる祭りは何か。",
        options: [
          "節分祭",
          "火祭り",
          "初午祭",
          "梅まつり"
        ],
        correctAnswer: 1,
        explanation: "愛宕神社では、毎年2月に「火祭り」が行われます。火防の神として古くから信仰を集め、祭りでは火渡り神事などが執り行われます。"
      },
      {
        id: 53,
        question: "日向市の大御神社から海岸沿いに続く参道「神話の道」の終点にある、伊勢神宮の遥拝所としての役割を持つ場所の名称は何か。",
        options: [
          "柱島",
          "さざれ石",
          "龍神岩",
          "遥拝殿"
        ],
        correctAnswer: 0,
        explanation: "柱島は、大御神社から海岸沿いに続く神話の道の先にあり、伊勢神宮の遥拝所として古来より信仰を集めてきました。"
      },
      {
        id: 54,
        question: "日向市の金ヶ浜海岸にある「さざれ石」は、君が代に歌われる「さざれ石」にちなんで設置された。この石の特徴は何か。",
        options: [
          "巨大な一枚岩",
          "小さな石が集まって固まった岩",
          "穴の開いた奇岩",
          "化石を含む岩"
        ],
        correctAnswer: 1,
        explanation: "さざれ石は、小さな石が長い年月をかけて集まり固まってできた岩です。君が代の「さざれ石の巌となりて」という歌詞は、この現象を詠んだものです。"
      },
      {
        id: 55,
        question: "延岡市の行縢山（むかばきやま）は、ある滝が有名である。この滝の名称は何か。",
        options: [
          "真名井の滝",
          "行縢の滝",
          "矢研の滝",
          "白滝"
        ],
        correctAnswer: 1,
        explanation: "行縢の滝は、行縢山の切り立った岩壁から落ちる高さ約77mの名瀑です。日本の滝百選にも選ばれており、神秘的な景観を見せます。"
      },
      {
        id: 56,
        question: "延岡市の北川町にある「祇園神社」の祭神は誰か。",
        options: [
          "天照大神",
          "素戔嗚尊",
          "大国主命",
          "事代主命"
        ],
        correctAnswer: 1,
        explanation: "祇園神社は、疫病退散の神として知られる素戔嗚尊を祀っています。延岡地域の祇園信仰の中心地として、古くから信仰を集めてきました。"
      },
      {
        id: 57,
        question: "日向市の美々津は、神武天皇が東征の際に船出した「お舟出の地」として知られる。この史実を記念して建てられた施設の名称は何か。",
        options: [
          "美々津記念館",
          "神武天皇宮",
          "お舟出の館",
          "立磐神社"
        ],
        correctAnswer: 2,
        explanation: "美々津には「お舟出の館」が建てられ、神武天皇の東征伝説や美々津の歴史を学ぶことができます。町並みは国の重要伝統的建造物群保存地区に選定されています。"
      },
      {
        id: 58,
        question: "美々津の「立磐神社」は、神武天皇が東征の際に何をしたとされる場所か。",
        options: [
          "戦勝祈願をした",
          "船を係留した岩がある",
          "軍議を開いた",
          "剣を研いだ"
        ],
        correctAnswer: 1,
        explanation: "立磐神社には、神武天皇が東征の際に船を係留したとされる「立磐」という巨岩があり、これを御神体として祀っています。"
      },
      {
        id: 59,
        question: "延岡市の須美江海岸は、「日豊海岸国定公園」の一部で、白い砂浜と青い海が美しい景勝地である。この海岸にある神社の名称は何か。",
        options: [
          "須美江神社",
          "海神神社",
          "浜宮神社",
          "龍宮神社"
        ],
        correctAnswer: 0,
        explanation: "須美江海岸には須美江神社が鎮座し、海の安全と豊漁を祈願する地域の信仰の中心となっています。"
      },
      {
        id: 60,
        question: "日向市の「クルスの海」の展望台から見える景色は、十字架の形だけでなく、ある文字にも見える。その文字は何か。",
        options: [
          "愛",
          "叶",
          "幸",
          "縁"
        ],
        correctAnswer: 1,
        explanation: "クルスの海は、上から見ると十字架の形に見えますが、角度によっては「叶」という文字にも見えることから、「願いが叶う岬」として人気のパワースポットとなっています。"
      }
    ]
  },
  {
    id: 7,
    title: "セット7: 都城・小林の霊験",
    category: "都城・小林",
    questions: [
      {
        id: 61,
        question: "都城市の神柱宮の主祭神で、九州を平定した神武天皇の皇子として知られる神は誰か。",
        options: [
          "建磐龍命",
          "神八井耳命",
          "彦五瀬命",
          "手力雄命"
        ],
        correctAnswer: 0,
        explanation: "神柱宮は、神武天皇の孫である建磐龍命を主祭神として祀っています。この神は九州統治を命じられ、都城の地を治めたとされます。"
      },
      {
        id: 62,
        question: "都城市の神柱宮で毎年8月に開催される大祭の名称は何か。",
        options: [
          "六月灯",
          "六月燈",
          "夏祭り",
          "納涼祭"
        ],
        correctAnswer: 0,
        explanation: "神柱宮の六月灯は、毎年旧暦の6月（現在は8月）に開催される南九州特有の夏祭りです。数千の灯籠が境内を照らし、多くの参拝者で賑わいます。"
      },
      {
        id: 63,
        question: "小林市の霧島岑神社は、霧島山系の霊峰を神体山としている。この神社の主祭神は誰か。",
        options: [
          "天照大神",
          "瓊瓊杵尊",
          "伊弉諾尊・伊弉冉尊",
          "木花開耶姫"
        ],
        correctAnswer: 2,
        explanation: "霧島岑神社は、国生みの神であるイザナギ・イザナミを主祭神として祀っています。霧島山系の自然信仰と結びついた古社です。"
      },
      {
        id: 64,
        question: "都城市の母智丘神社がある母智丘公園は、春になると約何本の桜が咲き誇る桜の名所として知られているか。",
        options: [
          "約1,000本",
          "約2,600本",
          "約5,000本",
          "約10,000本"
        ],
        correctAnswer: 1,
        explanation: "母智丘公園には約2,600本の桜が植えられており、「日本さくら名所100選」にも選ばれています。春には桜のトンネルができる絶景スポットです。"
      },
      {
        id: 65,
        question: "小林市の生駒高原は、秋になると一面に咲く花で有名である。その花は何か。",
        options: [
          "コスモス",
          "ひまわり",
          "ラベンダー",
          "ポピー"
        ],
        correctAnswer: 0,
        explanation: "生駒高原は、秋になると約100万本のコスモスが咲き誇る絶景スポットです。霧島連山を背景にしたコスモス畑は、多くの観光客を魅了します。"
      },
      {
        id: 66,
        question: "都城市の早水神社の境内にある「早水公園」は、あるスポーツ施設で有名である。そのスポーツとは何か。",
        options: [
          "野球",
          "陸上競技",
          "サッカー",
          "弓道"
        ],
        correctAnswer: 0,
        explanation: "早水公園には早水球場があり、プロ野球のキャンプ地としても使用されています。また、あじさいの名所としても知られています。"
      },
      {
        id: 67,
        question: "小林市の「出の山湧水」は、環境省の名水百選に選ばれている。この湧水の特徴として正しいものはどれか。",
        options: [
          "日本で最も湧水量が多い",
          "水温が年間を通じて約17度で一定",
          "炭酸を含む鉱泉",
          "海水が混じる汽水"
        ],
        correctAnswer: 1,
        explanation: "出の山湧水は、年間を通じて水温約17度、1日約6万トンの湧水量を誇ります。透明度が高く、淡水魚の生息地としても貴重な環境です。"
      },
      {
        id: 68,
        question: "都城市の関之尾滝は、日本の滝百選に選ばれている名瀑である。この滝の幅は約何メートルか。",
        options: [
          "20m",
          "40m",
          "60m",
          "80m"
        ],
        correctAnswer: 1,
        explanation: "関之尾滝は、幅約40m、高さ約18mの大滝で、豪快な水しぶきを上げる景観が見事です。周辺には国の天然記念物に指定された甌穴群もあります。"
      },
      {
        id: 69,
        question: "小林市の陰陽石は、自然が作り出した奇岩で、男女一対の石として信仰を集めている。この石が祀られている神社の名称は何か。",
        options: [
          "陰陽神社",
          "男石女石神社",
          "諏訪神社",
          "御池神社"
        ],
        correctAnswer: 2,
        explanation: "陰陽石は諏訪神社の境内に祀られており、子宝・縁結びの御利益があるとされています。自然が作り出した男女の象徴として崇められています。"
      },
      {
        id: 70,
        question: "都城市の「母智丘」の名前の由来となった伝説によると、ある神がこの丘で何をしたとされているか。",
        options: [
          "眠った",
          "子を産んだ",
          "国見をした",
          "祭祀を行った"
        ],
        correctAnswer: 1,
        explanation: "母智丘の名前は、神功皇后の伝説に由来するとされ、「母が子を産んだ丘」という意味から名付けられたという説があります。安産・子育ての聖地として信仰されています。"
      }
    ]
  },
  {
    id: 8,
    title: "セット8: 日南・串間の聖域",
    category: "日南・串間",
    questions: [
      {
        id: 71,
        question: "日南市の飫肥城下町に鎮座し、飫肥藩の総鎮守として崇敬された神社の名称は何か。",
        options: [
          "飫肥神社",
          "豫章館神社",
          "田ノ上八幡神社",
          "飫肥天満宮"
        ],
        correctAnswer: 2,
        explanation: "田ノ上八幡神社は、飫肥藩5万1千石の総鎮守として、歴代藩主の崇敬を集めました。飫肥城下町の守護神として、現在も地域の信仰の中心です。"
      },
      {
        id: 72,
        question: "日南市の猪八重渓谷にある「猪八重神社」は、滝を御神体としている。この滝の名称は何か。",
        options: [
          "真名井の滝",
          "猪八重の滝",
          "轟の滝",
          "不動の滝"
        ],
        correctAnswer: 1,
        explanation: "猪八重神社は、猪八重の滝を御神体として祀っています。高さ約20mの滝が神秘的な雰囲気を醸し出し、水の神として信仰を集めています。"
      },
      {
        id: 73,
        question: "串間市の都井岬に野生馬「御崎馬」が生息しているが、この馬は国の天然記念物に指定されている。御崎馬が暮らす岬には、ある神社が鎮座している。その神社の名称は何か。",
        options: [
          "都井神社",
          "御崎神社",
          "駒形神社",
          "馬頭観音"
        ],
        correctAnswer: 1,
        explanation: "御崎神社は、都井岬の突端に鎮座し、航海安全の神として古くから信仰されています。野生の御崎馬が草を食む神聖な雰囲気の中にあります。"
      },
      {
        id: 74,
        question: "日南市北郷町の潮嶽神社で行われる「潮嶽神楽」の特徴として正しいものはどれか。",
        options: [
          "夜を徹して行われる",
          "海幸彦を主題とした演目がある",
          "春に行われる",
          "上記すべて"
        ],
        correctAnswer: 3,
        explanation: "潮嶽神楽は、春に一晩中かけて奉納される神楽で、主祭神である海幸彦を主題とした「魚釣舞」などの独特の演目があります。"
      },
      {
        id: 75,
        question: "串間市の大束にある「石波海岸」は、その独特の地形から何と呼ばれているか。",
        options: [
          "恐竜の足跡",
          "鬼の洗濯岩",
          "天狗の踏み石",
          "龍の背中"
        ],
        correctAnswer: 1,
        explanation: "石波海岸には、青島や鵜戸と同様の「鬼の洗濯岩」と呼ばれる波状岩の地形が広がっており、日南海岸国定公園の一部を成しています。"
      },
      {
        id: 76,
        question: "日南市の榎原神社は、「榎原」という地名の由来となった巨大な榎の御神木があることで知られる。この神社の主祭神は誰か。",
        options: [
          "木花開耶姫",
          "猿田彦命",
          "大山祇命",
          "菅原道真"
        ],
        correctAnswer: 2,
        explanation: "榎原神社は、山の神である大山祇命を主祭神として祀っています。巨大な榎の御神木は、樹齢数百年とされ、地域のシンボルとなっています。"
      },
      {
        id: 77,
        question: "串間市の本城温泉は、ある伝説の人物が発見したと伝えられている。その人物は誰か。",
        options: [
          "神武天皇",
          "日本武尊",
          "弘法大師",
          "行基菩薩"
        ],
        correctAnswer: 2,
        explanation: "本城温泉は、弘法大師が杖で地面を突いて湧き出させたという伝説があります。「弘法の湯」とも呼ばれ、古くから湯治場として親しまれています。"
      },
      {
        id: 78,
        question: "日南市の「海幸・山幸の伝説」を伝える鵜戸神宮では、海幸彦が失くした釣り針を探すために山幸彦が訪れた場所とされるのはどこか。",
        options: [
          "海神の宮（竜宮）",
          "高天原",
          "黄泉の国",
          "常世の国"
        ],
        correctAnswer: 0,
        explanation: "山幸彦は、兄の海幸彦から借りた釣り針を失くし、それを探すために海神の宮（竜宮）を訪れたという神話があります。そこで豊玉姫と出会い、結婚しました。"
      },
      {
        id: 79,
        question: "日南市の風田（かざた）地区にある「風田の森」は、ある自然現象を起こす場所として古くから信仰されている。その自然現象とは何か。",
        options: [
          "霧の発生",
          "風が吹く",
          "雨が降る",
          "虹が出る"
        ],
        correctAnswer: 1,
        explanation: "風田の森は、「風を呼ぶ森」として古くから信仰されており、日照りの際にはこの森で雨乞いや風乞いの祈願が行われてきました。"
      },
      {
        id: 80,
        question: "串間市の都井岬灯台は、「日本の灯台50選」に選ばれている。この灯台の特徴として正しいものはどれか。",
        options: [
          "内部を見学できる",
          "白亜の美しい灯台",
          "周辺に野生馬がいる",
          "上記すべて"
        ],
        correctAnswer: 3,
        explanation: "都井岬灯台は、内部を見学できる全国でも珍しい灯台で、白亜の美しい姿と、周辺に御崎馬が草を食む独特の景観で知られています。"
      }
    ]
  },
  {
    id: 9,
    title: "セット9: 特別な神事と祭礼",
    category: "神事・祭礼",
    questions: [
      {
        id: 81,
        question: "毎年10月に宮崎神宮で行われる「神武さま」と呼ばれる大祭の正式名称は何か。",
        options: [
          "宮崎神宮例大祭",
          "神武天皇祭",
          "御神幸祭",
          "神武天皇大祭"
        ],
        correctAnswer: 0,
        explanation: "宮崎神宮例大祭は「神武さま」の愛称で親しまれ、毎年10月下旬に開催されます。神幸行列が市内を練り歩き、多くの人々が訪れる宮崎最大級の祭りです。"
      },
      {
        id: 82,
        question: "高千穂の夜神楽は、毎年11月から翌年2月にかけて各集落で奉納される。この期間に行われる夜神楽の回数は約何回か。",
        options: [
          "約20回",
          "約33回",
          "約50回",
          "約100回"
        ],
        correctAnswer: 1,
        explanation: "高千穂町内には約20の集落があり、それぞれが1～2回の夜神楽を奉納するため、シーズン中には町内全体で約33回の夜神楽が行われます。"
      },
      {
        id: 83,
        question: "青島神社で毎年1月に行われる、海の中に入って身を清める神事の名称は何か。",
        options: [
          "裸祭り",
          "海中みそぎ祭",
          "寒中禊",
          "潮祓い"
        ],
        correctAnswer: 1,
        explanation: "青島神社の「海中みそぎ祭」は、毎年成人の日前後に行われる伝統神事で、参加者が冬の海に入って身を清め、一年の無病息災を祈願します。"
      },
      {
        id: 84,
        question: "鵜戸神宮で行われる「おちちあめ祭り」は、毎年いつ開催されるか。",
        options: [
          "1月初旬",
          "3月初旬",
          "5月初旬",
          "10月初旬"
        ],
        correctAnswer: 3,
        explanation: "おちちあめ祭りは、毎年10月の第2日曜日に開催され、子育てや安産の御利益を授かるために多くの参拝者が訪れます。"
      },
      {
        id: 85,
        question: "都萬神社で毎年7月に行われる「御田植祭」の特徴として正しいものはどれか。",
        options: [
          "早乙女による田植え",
          "神楽の奉納",
          "日本酒の奉納",
          "上記すべて"
        ],
        correctAnswer: 3,
        explanation: "都萬神社の御田植祭では、早乙女による伝統的な田植えが行われ、神楽が奉納され、日本酒発祥の地として日本酒も奉納される総合的な神事です。"
      },
      {
        id: 86,
        question: "高千穂神社で毎晩奉納される観光夜神楽の上演時間は何時からか。",
        options: [
          "午後6時",
          "午後7時",
          "午後8時",
          "午後9時"
        ],
        correctAnswer: 2,
        explanation: "高千穂神社では、毎晩午後8時から約1時間、代表的な神楽の演目4番を観光客向けに奉納しています。本来の夜神楽の雰囲気を手軽に体験できます。"
      },
      {
        id: 87,
        question: "西都市の「西都古墳まつり」で行われる「たいまつ行列」には、約何名が参加するか。",
        options: [
          "約100名",
          "約300名",
          "約500名",
          "約1000名"
        ],
        correctAnswer: 2,
        explanation: "西都古墳まつりのたいまつ行列には、古代衣装をまとった約500名が参加し、燃え盛るたいまつを手に古墳群を練り歩く壮大な祭りです。"
      },
      {
        id: 88,
        question: "東霧島神社の「振り向かずの坂」の石段を登る際のルールとして正しいものはどれか。",
        options: [
          "無言で登る",
          "振り向かずに一気に登る",
          "後ろ向きに登る",
          "目を閉じて登る"
        ],
        correctAnswer: 1,
        explanation: "東霧島神社の555段の石段は「振り向かずの坂」と呼ばれ、途中で振り向かずに一気に登り切ると願いが叶うとされています。"
      },
      {
        id: 89,
        question: "串間市の都井岬で毎年夏に行われる「都井岬火まつり」のクライマックスで点火されるものは何か。",
        options: [
          "かがり火",
          "柱松",
          "松明行列",
          "花火"
        ],
        correctAnswer: 1,
        explanation: "都井岬火まつりでは、高さ約30mの柱松に参加者が松明を投げ入れ、先端に仕掛けられた花火に点火するという勇壮な祭りが行われます。"
      },
      {
        id: 90,
        question: "椎葉村で毎年11月に行われる「椎葉平家まつり」で再現される伝説的な出来事は何か。",
        options: [
          "壇ノ浦の戦い",
          "那須大八郎と鶴富姫の恋物語",
          "平家の都落ち",
          "源平の和睦"
        ],
        correctAnswer: 1,
        explanation: "椎葉平家まつりでは、平家の追討使として椎葉に来た那須大八郎と、平家の姫・鶴富姫との悲恋の物語が、歴史絵巻として再現されます。"
      }
    ]
  },
  {
    id: 10,
    title: "セット10: 総合問題",
    category: "総合",
    questions: [
      {
        id: 91,
        question: "宮崎県内で国の重要文化財に指定されている神社建築として正しいものはどれか。",
        options: [
          "高千穂神社本殿",
          "鵜戸神宮本殿",
          "宮崎神宮本殿",
          "すべて"
        ],
        correctAnswer: 0,
        explanation: "高千穂神社の本殿・拝殿は、室町時代末期の建築で、国の重要文化財に指定されています。五間社流造という建築様式の優れた例です。"
      },
      {
        id: 92,
        question: "「日向三代」と呼ばれる神々とは、瓊瓊杵尊、彦火火出見尊と、もう一柱は誰か。",
        options: [
          "神日本磐余彦尊",
          "鵜鵝草葺不合尊",
          "天忍穂耳尊",
          "火明命"
        ],
        correctAnswer: 1,
        explanation: "日向三代とは、天孫降臨の瓊瓊杵尊、海幸山幸神話の彦火火出見尊、そして初代天皇の父である鵜鵝草葺不合尊を指します。"
      },
      {
        id: 93,
        question: "宮崎県の神社で「縁結び」の御利益で特に有名な神社の組み合わせとして正しいものはどれか。",
        options: [
          "青島神社と高千穂神社",
          "鵜戸神宮と都萬神社",
          "荒立神社と青島神社",
          "宮崎神宮と天岩戸神社"
        ],
        correctAnswer: 2,
        explanation: "荒立神社は天鈿女命と猿田彦命の夫婦神を祀り、青島神社は山幸彦と豊玉姫の恋物語の舞台とされることから、両社とも縁結びの御利益で特に人気があります。"
      },
      {
        id: 94,
        question: "宮崎県の神話ゆかりの地を巡る観光ルートとして整備されているものの名称は何か。",
        options: [
          "神話街道",
          "日向神話ロード",
          "神話の源流みやざき",
          "記紀の道"
        ],
        correctAnswer: 2,
        explanation: "「神話の源流みやざき」は、県内の神話ゆかりの地を巡る観光ルートとして整備されており、日本神話のふるさと宮崎の魅力を発信しています。"
      },
      {
        id: 95,
        question: "宮崎県で「パワースポット」として近年特に注目を集めている場所の組み合わせとして正しいものはどれか。",
        options: [
          "天安河原と鵜戸神宮と高千穂峡",
          "青島神社と大御神社と東霧島神社",
          "クルスの海と都井岬と生駒高原",
          "すべて"
        ],
        correctAnswer: 3,
        explanation: "宮崎県内には多くのパワースポットがあり、神話ゆかりの天安河原や鵜戸神宮、縁結びの青島神社、自然の神秘を感じるクルスの海など、多様なスポットが注目を集めています。"
      },
      {
        id: 96,
        question: "宮崎県の神社で、海岸の洞窟や岩場に本殿がある特徴的な立地の神社として正しいものはどれか。",
        options: [
          "鵜戸神宮",
          "大御神社",
          "青島神社",
          "すべて"
        ],
        correctAnswer: 0,
        explanation: "鵜戸神宮は、海岸の断崖にある洞窟の中に本殿がある、全国的にも珍しい立地の神社です。この独特の景観が多くの参拝者を魅了しています。"
      },
      {
        id: 97,
        question: "宮崎県の神社信仰の特徴として正しいものはどれか。",
        options: [
          "日本神話との関わりが深い",
          "山岳信仰や自然信仰が色濃い",
          "海の信仰が盛んである",
          "すべて"
        ],
        correctAnswer: 3,
        explanation: "宮崎県の神社信仰は、天孫降臨などの日本神話と深く結びつき、霧島山系などの山岳信仰、日向灘に面した海の信仰など、多様な信仰形態が共存しています。"
      },
      {
        id: 98,
        question: "宮崎県で「日本のどこか発祥の地」とされる神社・場所の組み合わせとして正しいものはどれか。",
        options: [
          "都萬神社（日本酒発祥の地）",
          "江田神社（みそぎ発祥の地）",
          "美々津（神武東征お舟出の地）",
          "すべて"
        ],
        correctAnswer: 3,
        explanation: "宮崎県には、日本の文化や歴史の「発祥の地」とされる場所が多く、都萬神社の日本酒、江田神社のみそぎ、美々津の神武東征など、多くの「始まりの地」があります。"
      },
      {
        id: 99,
        question: "宮崎県の神社で授与される特徴的なお守りや縁起物として正しいものはどれか。",
        options: [
          "鵜戸神宮の「おちちあめ」",
          "青島神社の「ハート形の絵馬」",
          "高千穂神社の「夫婦円満のお守り」",
          "すべて"
        ],
        correctAnswer: 3,
        explanation: "宮崎県の各神社では、その由緒や御利益に応じた特徴的なお守りや縁起物が授与されており、それぞれが人気を集めています。"
      },
      {
        id: 100,
        question: "宮崎県の神社や神話ゆかりの地を訪れる際の楽しみ方として推奨されるものはどれか。",
        options: [
          "神話の物語を学んでから訪れる",
          "自然の景観や季節の花を楽しむ",
          "地域の祭りや神事に参加する",
          "すべて"
        ],
        correctAnswer: 3,
        explanation: "宮崎県のパワースポット・神社巡りは、神話の学習、自然の景観、祭りや神事の体験など、多様な楽しみ方ができます。それぞれの場所の歴史や文化を深く理解することで、より豊かな体験となります。"
      }
    ]
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
